import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../../generic';

import styles from './EmptyState.module.less';

const EmptyState: VoidFunctionComponent = () => {
  return (
    <div className={styles.empty}>
      <Icon icon={icons.codeCompare} size="fa-3x" />
      <h2>Compare changes across revisions</h2>
      <div>Select a revision above so you can see which snippets are new, removed, or unchanged.</div>
    </div>
  );
};

export default EmptyState;
